import localForageHelper from '@helpers/localforage.helper'
import UserHelper from '@helpers/user.helper'
import User, { ProfileAdditionalInfo } from '@interfaces/user.interface'
import onEnvironmentChange from '@observables/environment.observable'
import onLangChange from '@observables/on-lang-change.observable'
import onUserChange from '@observables/user.observable'
import DakenService from '@services/daken/daken.service'
import LogService from '@services/log/log.service'
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Subscription } from 'rxjs'
import './language-selector.scoped.scss'
import { useLanguage } from '@/hooks/use-language/use-language.hook'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  lang?: 'en' | 'pt' | 'es'
}

export default ({ lang = 'en', className = '' }: Props) => {
  const { changeLang, currentLanguage, options, parseFlagByLang } = useLanguage(lang)

  return (
    <div className={`wrapper-language-selector ${className}`}>
      <span className={`fi fi-${parseFlagByLang(currentLanguage)}`} />
      <select className="language-selector" value={currentLanguage} onChange={changeLang} name="language-selector" id="language-selector">
        {options?.map((option) => (
          <option key={option?.value} value={option?.value}>
            {option?.label}
          </option>
        ))}
      </select>
    </div>
  )
}
